import { FolderCustomData } from '../../datapoints';
import getTodoFolderStore from '../../selectors/getTodoFolderStore';

export default function getFolderCustomData(): FolderCustomData {
    const folders = [...getTodoFolderStore().folders.values()];
    return {
        folders: folders.length,
        sharedFolders: folders.filter(f => f.IsSharedFolder).length,
    };
}
